var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"top"},[_c('p',[_vm._v(_vm._s(_vm.item.reason))]),_c('span',[_vm._v(_vm._s(_vm.item.alter))])]),_c('div',{staticClass:"bottom"},[_c('p',[_vm._v(_vm._s(_vm.item.create_time))])])])}
var staticRenderFns = []

export { render, staticRenderFns }